function timeChange(time, number = 60) {
	const hours = parseInt(time / 60 / 60 / 24);
	const minutes = parseInt((time / number) % 60);
	const seconds = parseInt(time % number);
	return (
		(hours > 0 ? `${toZero(hours)} :` : '') +
		toZero(minutes) +
		':' +
		toZero(seconds)
	);
}

function toZero(num) {
	return num < 10 ? '0' + num : num;
}

const formatDuration = (duration) => {
	const time = parseInt(duration);
	if (!time) return '--';
	return timeChange(time / 1000);
};

export { formatDuration };
